export default "__VITE_ASSET__CF9zf8oF__"